import ApiService from './api.service'

const UsersService = {    
  get(companyId, name, typePublicCode, page, count) {
    return ApiService.get('api/companies', {
      params: {
        CompanyId: companyId,
        Name: name,
        TypePublicCode: typePublicCode,
        Page: page,
        Count: count
      }
    })
  },

  getBalanceLogs(companyId, action, dateFrom, dateTo, page, count) {
    return ApiService.get('api/companies/balance', {
      params: {
        CompanyId: companyId,
        Action: action,
        DateFrom: dateFrom,
        DateTo: dateTo,
        Page: page,
        Count: count
      }
    })
  },

  getTaskTariffs(energyTypePublicCode, nodeTypePublicCode, taskTypePublicCode) {
    return ApiService.get('/api/companies/tariffs', {
      params: {
        EnergyTypePublicCode: energyTypePublicCode,
        NodeTypePublicCode: nodeTypePublicCode,
        TaskTypePublicCode: taskTypePublicCode
      }
    })
  },

  getTypes(id) {
    return ApiService.get('api/companies/types', {
      params: {
        Id: id,
      }
    })
  },

  create(company) {
    return ApiService.post('api/companies', company)
  },

  update(company) {
    return ApiService.put('api/companies', company)
  },

  updateTariff(id, value) {
    let tariff = {
      id: id,
      value: value
    }
    return ApiService.put('api/companies/tariffs', tariff)
  },

  delete(companyId) {
    return ApiService.delete(`api/companies/${companyId}`)
  },

  addBalance(idCompany, countUnits) {
    return ApiService.post('api/companies/balance', {idCompany: idCompany, countUnits: countUnits})
  },
}

export default UsersService